import produce from 'immer';
import { ActionsUnion, createAction } from 'utils/actionHelpers';

export enum ActionTypes {
  TOGGLE_BLOCKING_UI = 'TOGGLE_BLOCKING_UI',
  TOGGLE_SIDEBAR_PANEL = 'TOGGLE_SIDEBAR_PANEL',
  HIDE_SIDEBAR = 'HIDE_SIDEBAR',

  TIPS_SAVE = 'TIPS_SAVE',
  CONFIG_RECAPTCHA_SAVE = 'CONFIG_RECAPTCHA_SAVE',
  GET_TIP = 'GET_TIP',
  SET_COUNTRIES = "SET_COUNTRIES",
}

export const initialState = {
  isUIBlocked: false,
  activePanelId: undefined,
  blockedUIMsg: null,
  blockedUITimer: null,
  tips: {},
  recaptcha: { isDisabled: true },
  countries: [],
};

interface IBlockUIWithMsg {
  state: boolean;
  message: string;
  timer: number;
}

export const Actions = {
  toggleUIBlocking: (payload: boolean | IBlockUIWithMsg) =>
    createAction(ActionTypes.TOGGLE_BLOCKING_UI, payload),

  toggleSidebarPanel: (payload?: number) =>
    createAction(ActionTypes.TOGGLE_SIDEBAR_PANEL, payload),

  hideSidebar: () =>
    createAction(ActionTypes.HIDE_SIDEBAR),
  configRecapthaSave: (payload: any) =>
    createAction(ActionTypes.CONFIG_RECAPTCHA_SAVE, payload),
  tipsSave: (payload: any) =>
    createAction(ActionTypes.TIPS_SAVE, payload),
  getTip: (payload: string) => createAction(ActionTypes.GET_TIP, payload),
  setCountries: (payload: ICountry[]) =>
    createAction(ActionTypes.SET_COUNTRIES, payload),
};

export interface IAppState {
  isUIBlocked: boolean;
  blockedUIMsg: string | null;
  blockedUITimer: number | null;
  activePanelId?: number;
  tips: { [key: string]: string };
  recaptcha: { isDisabled: boolean };
  countries: ICountry[];
}

export interface ICountry {
  id: number;
  code: string;
  name: string;
}

export type AppAction = ActionsUnion<typeof Actions>;

export default (state: IAppState = initialState, action: AppAction) =>
  produce(state, (draft: IAppState) => {
    switch (action.type) {
      case ActionTypes.TOGGLE_BLOCKING_UI:
        draft.isUIBlocked =
          typeof action.payload === 'object'
            ? action.payload.state
            : action.payload;
        draft.blockedUIMsg =
          typeof action.payload === 'object' ? action.payload.message : null;
        draft.blockedUITimer =
          typeof action.payload === 'object' ? action.payload.timer : null;
        return;
      case ActionTypes.TOGGLE_SIDEBAR_PANEL:
        draft.activePanelId = draft.activePanelId === action.payload ? undefined : action.payload;
        return;
      case ActionTypes.HIDE_SIDEBAR:
        draft.activePanelId = undefined;
        return;
      case ActionTypes.TIPS_SAVE:
        draft.tips = action.payload.tips;
        return;
      case ActionTypes.CONFIG_RECAPTCHA_SAVE:
        draft.recaptcha.isDisabled = action.payload.recaptcha.isDisabled;
        return;
      case ActionTypes.SET_COUNTRIES:
        draft.countries = action.payload;
        return;
    }
  });
